import { render, staticRenderFns } from "./mFooters.vue?vue&type=template&id=7c4a534c&scoped=true"
import script from "./mFooters.vue?vue&type=script&lang=js"
export * from "./mFooters.vue?vue&type=script&lang=js"
import style0 from "./mFooters.vue?vue&type=style&index=0&id=7c4a534c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4a534c",
  null
  
)

export default component.exports